import { z } from "zod";

// TES-1646 (Ö-1015 ✅ 2026-10-30) — how a new patient on the optional care
// meeting track wants to be assessed, chosen after her health declaration:
//
//   > "Efter inskickad F-02 väljs skriftlig bedömning eller frivilligt
//   > läkarbesök … Valet sparas uttryckligen på ärendet med tidpunkt; inget
//   > val härleds ur frånvaro av bokning."
//
//   written — "Fortsätt med skriftlig bedömning": the doctor assesses her
//             declaration and evidence and decides in writing;
//   meeting — "Boka ett digitalt vårdmöte": she books a meeting herself, at
//             the voluntary meeting's price.
//
// Stored on the patient (Patient.assessmentChoice + assessmentChoiceAt). Her
// latest choice wins; changing it keeps everything she has already given.
//
// For code that builds on the choice (TES-1648 photos, TES-1649 waist):
// read it through the API's `onWrittenAssessmentTrack` /
// `storedAssessmentChoice` (apps/api/src/patient/care-meeting-optional.ts),
// never from the column alone. The column holds what she chose; whether it
// counts also depends on the track (tenant flag, group, positive F-01), on a
// meeting the doctor or her flags require (which overrides it), and on a
// meeting she has booked (which puts her on the meeting track).
export const ASSESSMENT_CHOICES = ["written", "meeting"] as const;
export const assessmentChoiceSchema = z.enum(ASSESSMENT_CHOICES);
export type AssessmentChoice = z.infer<typeof assessmentChoiceSchema>;

/** POST patient-api/v1/me/assessment-choice */
export const recordAssessmentChoiceSchema = z
  .object({ choice: assessmentChoiceSchema })
  .strict();
export type RecordAssessmentChoice = z.infer<
  typeof recordAssessmentChoiceSchema
>;

/**
 * GET and POST patient-api/v1/me/assessment-choice. `choice` and `chosenAt`
 * are her stored choice (null before she has made one). `offered` is whether
 * the choice is hers to make now: on the optional track, with a submitted
 * health declaration, and no meeting required of her.
 */
export const assessmentChoiceStateSchema = z.object({
  choice: assessmentChoiceSchema.nullable(),
  chosenAt: z.string().nullable(),
  offered: z.boolean(),
});
export type AssessmentChoiceState = z.infer<typeof assessmentChoiceStateSchema>;
